import React from 'react';
import { Metric as MetricType } from '@hud/portal-dtos/webapp-common.dto';
import Trend, { TrendVariants } from '../Trend/Trend';

export interface MetricTrendProps {
  metric?: MetricType;
  variant?: TrendVariants;
  tooltip?: string;
}

export default function MetricTrend({ metric, variant, tooltip }: MetricTrendProps) {
  if (!metric || !metric.trend) {
    return;
  }

  return (
    <Trend
      value={metric.trend}
      symbol={metric.symbol}
      variant={variant}
      tooltip={tooltip}
    />
  );
}
